module.exports = __webpack_public_path__ + "static/media/exp1.85523771.png";